import React from "react";
import { CheckoutModal, CheckoutModalLinkParagraph } from "./CheckoutModal-styled";
import { ModalTextParagraph } from "../Modals-styled";


interface Props {
  checkoutModalVisible:boolean,
  checkoutURI:string,
  setCheckoutModalVisibility:(value)=>void,
}

export default class extends React.Component<Props,{}> {
  constructor(props: Props) {
    super(props);
  };// /constructor()

  render = () => {
    const {
      checkoutModalVisible,
      checkoutURI,
      setCheckoutModalVisibility,
    } = this.props;

    return(
      <CheckoutModal className="threed-configurator-checkout-modal"
        title="Thank you!"
        visible={checkoutModalVisible}
        footer={null}
        onCancel={() => { setCheckoutModalVisibility(false) }}
        maskClosable={false}
      >
          <ModalTextParagraph>
            <span>We are processing your order.</span>
          </ModalTextParagraph>

          {checkoutURI &&
            <CheckoutModalLinkParagraph>
              <span>If your browser does not redirect you, please click here: <a href={checkoutURI}>{checkoutURI}</a>.</span>
            </CheckoutModalLinkParagraph>
          }
          
      </CheckoutModal>
    )
  };// /render()

};// /class